import {
  configureTaskBeforeCreate,
  updateLastUniqueCorrelativeId,
  updateParentAfterTaskCreation,
  trackTaskCreation
} from './utils';

function createTaskWithChildAction(dto) {
  const { gantt, sector, parentsToUpdate, task, parent } = dto;

  let newTaskId;

  gantt.batchUpdate(() => {
    const currentParent = gantt.getTask(parent);

    const newUID = configureTaskBeforeCreate({
      task,
      currentParent,
      sector,
      gantt
    });

    const updatedCorrelativeIds = updateLastUniqueCorrelativeId({
      sector,
      newUID
    });
    gantt.lastUniqueCorrelativeIds = updatedCorrelativeIds;

    newTaskId = gantt.createTask(task, parent);

    const createdTask = gantt.getTask(newTaskId);
    if (createdTask) {
      createdTask.correlative_id = gantt.getTaskNumber(createdTask);
    }

    if (currentParent) {
      const freshParent = gantt.getTask(currentParent.id);
      if (freshParent) {
        updateParentAfterTaskCreation(freshParent, newTaskId, parentsToUpdate);
      }
    }
  });

  trackTaskCreation({
    parent,
    newTaskId,
    task
  });

  return newTaskId;
}

export { createTaskWithChildAction };
